import React, { Component, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import thali from "./image/thali.png";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import IconButton from "@material-ui/core/IconButton";
import "./item.css";
//import { Redirect } from 'react-router-dom'
// window.onpopstate  = (e) => {
//    window.location="http://localhost:3000/"
// }
export default class OrderF extends Component {
  //  componentWillMount() {
  //      debugger;
  //     window.onpopstate  = (e) => {
  //         this.props.history.replace("/");
  //         }

  // }

  Change = () => {

    
    this.props.history.push(
      "/food-booking/Allorder/details/" +
        this.props.match.params.id +
        "/" +
        this.props.match.params.email
    );
  };
  home = () => {
    this.props.history.replace("/food-booking");
  };

  render() {
    return (
      <Fragment>
        {" "}
        <Grid
          container
          alignItems="center"
          spacing={1}
          style={{
            backgroundColor: "#45A04A",
            position: "fixed",
            margin: "0px",
            top: 0,
            zIndex: 100
          }}
        >
          <Grid item xs={2} style={{ marginLeft: "10px" }}>
            <IconButton
              edge="start"
              style={{ color: "white" }}
              onClick={this.home}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
            Confirm Order
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            position: "fixed",
            backgroundColor: "white",
            margin: "0px",
            bottom: 0,
            zIndex: 100,
            width: "100%",
            height: "10%",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
          }}
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography align="center">
              <Button
                size="large"
                variant="outlined"
                style={{
                  color: "#3D83E1",
                  maxWidth: "350px",
                  borderColor: "#3D83E1",
                  width: "90%"
                }}
                onClick={this.Change}
              >
                Open My Food Orders
              </Button>
            </Typography>
          </Grid>
        </Grid>
        <Container
          style={{ width: "80%", marginTop: "80px", marginBottom: "5%" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="center">
                <img src={thali} alt="thali" height="75px" width="75px" />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" color="textSecondary" align="center">
                <span className="sudo2"> Your Order has been placed </span>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" color="textSecondary" align="center">
                <span className="sudo2">
                  Booking ID is {this.props.match.params.id}{" "}
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Fragment>
    );
  }
}
